<!-- 入驻企业 -->
<template>
  <div>
    <div class="mapImg width">
      <div class="mapLeft">
        <baidu-map class="map" center="北京" :zoom="5" :scroll-wheel-zoom="true">
          <div v-for="(item,i) in markers" :key="i">
            <bm-marker :position="{lng: item.lng, lat: item.lat}" @click="lookDetail(item)">
              <bm-info-window
                :show="item.showFlag==0?false:true"
                @close="infoWindowClose(item)"
                @open="infoWindowOpen(item)"
              >
                <p>{{item.name}}</p>
                <p>入驻时间：{{item.add_time}}</p>
                <p>主营业务：{{item.yewu}}</p>
              </bm-info-window>
            </bm-marker>
          </div>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :panel="false"
            :location="location"
          ></bm-local-search>
        </baidu-map>
      </div>
      <div class="mapRight">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>入驻企业分布</span>
            <el-button
              type="primary"
              size="small"
              @click="fenlei(2)"
              v-show="false"
              style="float:right"
            >按市</el-button>
            <el-button
              type="primary"
              size="small"
              @click="fenlei(2)"
              v-show="btnShow"
              style="float:right"
            >按市</el-button>
            <el-button
              type="primary"
              size="small"
              plain
              @click="fenlei(2)"
              v-show="!btnShow"
              style="float:right"
            >按市</el-button>
            <el-button
              type="primary"
              size="small"
              @click="fenlei(1)"
              v-show="!btnShow"
              style="float:right"
            >按省</el-button>
            <el-button
              type="primary"
              size="small"
              plain
              @click="fenlei(1)"
              v-show="btnShow"
              style="float:right"
            >按省</el-button>
          </div>
          <div class="itemAll clearfix">
            <div
              v-for="(item,i) in cityData"
              :key="i"
              class="text item"
              @click="changeCity(fenType==1?item.province_name:item.city_name)"
            >
              <span>{{fenType==1?item.province_name:item.city_name}}</span>
              <span style="margin-left:40px">{{item.count}}</span>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 快速查找 -->
    <div class="fastSoo width">
      <el-form :inline="true" :model="menuForm" class="demo-form-inline" size="small">
        <el-form-item label="行业筛选">
          <el-select
            v-model="menuForm.typeid"
            filterable
            clearable
            placeholder="请选择"
            style="width:100%"
          >
            <el-option
              v-for="(item ,i) in selectindustry"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索">
          <el-input v-model="menuForm.name" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 企业列表 -->
    <div class="priseList width">
      <div class="priseListItem" v-for="(item,i) in priseList" :key="i">
        <div class="priseItemImg">
          <img :src="item.cover_logo" alt srcset />
        </div>
        <div class="priseItemContent">
          <div class="priseItemContentTitle">{{item.name}}</div>
          <div class="priseItemContentDai">
            <span>
              <strong>法定代表人：</strong>
              {{item.daibiao}}
            </span>
            <span>
              <strong>注册资本：</strong>
              {{item.ziben}}万元人民币
            </span>
            <span>
              <strong>成立日期：</strong>
              {{item.create_time | formatDate1}}
            </span>
          </div>
          <div class="priseItemContentintu">
            <strong>企业简介：</strong>
            {{item.introduction}}
          </div>
          <div class="priseItemContentAddress">
            <span>
              <strong>企业官网：</strong>
              {{item.website}}
            </span>
            <span>
              <strong>公司地址：</strong>
              {{item.address}}
            </span>
          </div>
        </div>
        <div class="mapContent">
          <baidu-map
            class="maps"
            :scroll-wheel-zoom="true"
            :center="{lng: item.lng, lat: item.lat}"
            :zoom="15"
          >
            <bm-marker :position="{lng: item.lng, lat: item.lat}"></bm-marker>
          </baidu-map>
        </div>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="menuForm.page"
        :page-size="4"
        layout="total,prev, pager, next, jumper"
        :total="total"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      markers: [],
      cityData: [],
      fenType: 1,
      keyword: '',
      location: '',
      menuForm: { page: 1 },
      selectindustry: [],
      priseList: [],
      btnShow: false,
      total: 0,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.mapdatas()
    this.allindustry()
    this.getEnterprise()
  },
  mounted() {},
  methods: {
    // 获取地图
    async mapdatas() {
      const res = await this.$http.post('/mapdatas', { type: this.fenType }) // eslint-disable-line no-unused-vars
      this.markers = res.data.left
      this.cityData = res.data.right
    },
    // 切换省市
    async fenlei(i) {
      this.fenType = i
      const res = await this.$http.post('/mapdatas', { type: this.fenType }) // eslint-disable-line no-unused-vars
      this.cityData = res.data.right
      this.btnShow = !this.btnShow
    },
    // 切换城市
    changeCity(i) {
      this.keyword = i
      this.location = i
    },
    // 获取所有行业数据
    async allindustry() {
      const res = await this.$http.post('/allindustry') // eslint-disable-line no-unused-vars
      this.selectindustry = res.data.data
    },
    // 获取企业列表
    async getEnterprise() {
      const res = await this.$http.post('/enterprise', this.menuForm) // eslint-disable-line no-unused-vars
      this.priseList = res.data.data
      this.total = res.data.total
    },
    // 关闭弹窗
    lookDetail(marker) {
      marker.showFlag = true
    },
    // 关闭弹窗
    infoWindowClose(marker) {
      marker.showFlag = false
    },
    // 打开弹窗
    infoWindowOpen(marker) {
      marker.showFlag = true
    },
    onSubmit() {
      console.log('submit!')
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.menuForm.page = val
      this.getEnterprise()
    },
  },
}
</script>

<style lang="less" scoped>
.mapImg {
  display: flex;
  height: 600px;
  .mapLeft {
    flex: 2;
  }
  .mapRight {
    flex: 1;
    height: 100%;
    margin-left: 10px;
    .itemAll {
      height: 490px;
    }
    .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
      float: left;
      width: 50%;
      cursor: pointer;
    }
  }
}
.map {
  width: 100%;
  height: 600px;
}
.maps {
  width: 100%;
  height: 200px;
}
.fastSoo {
  background-color: #fff;
  margin-top: 10px;
  padding-top: 20px;
  padding-left: 20px;
}

.priseList {
  background-color: #fff;
  margin-top: 10px;
  padding-top: 20px;
  padding-left: 20px;
  .priseListItem {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    .priseItemImg {
      flex: 1;
      margin-right: 30px;
      img {
        width: 280px;
        height: 170px;
        border-radius: 4px;
      }
    }
    .priseItemContent {
      flex: 4;
      margin-right: 10px;
      .priseItemContentTitle {
        font-weight: 700;
        font-size: 20px;
        margin-bottom: 50px;
      }
      .priseItemContentDai {
        display: flex;
        margin-bottom: 20px;
        span:first-child {
          max-width: 200px;
        }
        span {
          flex: 1;
        }
      }
      .priseItemContentintu {
        margin-bottom: 10px;
      }
      .priseItemContentAddress {
        display: flex;
        span:first-child {
          max-width: 200px;
        }
        span {
          flex: 1;
        }
      }
    }
    .mapContent {
      flex: 2;
      margin-right: 10px;
    }
  }
}
</style>
